// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsRetirement = {
  benefits_section_retirement: {
    contentful_name: '[DEFAULT] Benefits Section - Retirement',
    employer_match: '雇主匹配',
    vesting_schedule: '归属时间表',
    automatic_enrollment: '自动注册',
    employee_contribution: '员工缴费',
    retirement_401k:
      '{employerName}为您提供401(k)账户,帮助您为退休储蓄。但与普通储蓄账户不同,该账户为您提供特殊的税收优惠。计划特点的要点如上所示,但您应查阅您的计划文件以了解完整详情。',
    retirement_403b:
      '{employerName}为您提供403(b)账户,帮助您为退休储蓄。但与普通储蓄账户不同,该账户为您提供特殊的税收优惠。计划特点的要点如上所示,但您应查阅计划文件以了解完整详情。',
    retirement_403combo:
      '{employerName}为您提供403(b)和457(b)账户组合,帮助您为退休储蓄。但与普通储蓄账户不同,该账户为您提供特殊的税收优惠。计划功能的要点如上所示,但您应查阅计划文件以了解完整详情。',
    retirement_457b:
      '{employerName}为您提供457(b)账户,帮助您为退休储蓄。但与普通储蓄账户不同,该账户为您提供特殊的税收优惠。计划特点的要点如上所示,但您应查阅计划文件以了解完整详情。',
    retirement:
      '{employerName}为您提供一个退休账户,帮助您为退休储蓄。但与普通储蓄账户不同,该账户为您提供特殊的税收优惠。计划特点的要点如上所示,但您应查阅您的计划文件以了解完整详情。',
    employee_contribution_description:
      '您可以在每次发薪时缴纳最多工资的 {contributionPercent}%,直到达到当年的限额。',
    automatic_enrollment_description:
      '为帮助您开始为退休储蓄,系统可能会自动设置您贡献工资的 {autoEnrollPercent}%。您可以随时选择增加或减少您的缴款金额。',
    matching_tier_1:
      '您每存入一美元,最高可达您工资的 {tier1PercentMatched}%,我们将向您的账户中存入 {tier1RatioMatched} 作为匹配。',
    matching_tier_2:
      '然后,对于您在第一档和工资的{tier2PercentMatched}%之间贡献的每一美元,将有{tier2RatioMatched}存入您的账户作为匹配。',
    matching_tier_3:
      '最后,对于您在第二档和工资的{tier3PercentMatched}%之间贡献的每一美元,将有{tier3RatioMatched}存入您的账户作为匹配。',
    vesting_schedule_less_than_one_year:
      '虽然您可能会收到账户的匹配供款,但您需要工作一定年限才能保留100%的额外资金。您需要工作<1年才能获得100%的供款。',
    vesting_schedule_multi_year:
      '虽然您可能会收到账户的匹配供款,但您需要工作一定年限才能保留100%的额外资金。您需要工作{finishedVestingIndex}年才能获得100%的供款。',
    vesting_schedule_six_years:
      '虽然您可能会收到与您账户相匹配的供款,但您需要工作一定年限才能保留100%的额外资金。您需要至少工作6年才能获得100%的供款。',
  },
};
